"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var spinner_icon_style_1 = require("./spinner.icon.style");
function Spinner(props) {
    return (react_1.default.createElement("div", { className: "circle-loader-wrapper" },
        react_1.default.createElement("svg", { className: spinner_icon_style_1.movingDiv, width: props.size, height: props.size, viewBox: "0 0 64 64" },
            react_1.default.createElement("circle", { cx: "50%", cy: "50%", r: "45.5%", fill: "transparent", stroke: "#dbe4e8", strokeWidth: "5px" }),
            react_1.default.createElement("circle", { className: spinner_icon_style_1.movingCircle, cx: "50%", cy: "50%", r: "45.5%", fill: "transparent", stroke: "#3fb2e5", strokeLinecap: "round", strokeWidth: "5px", strokeDasharray: "182", strokeDashoffset: "182" }))));
}
exports.Spinner = Spinner;
